import {Component, Input, isDevMode, OnChanges, OnDestroy, OnInit, SimpleChanges} from '@angular/core';
import {FormGroup, Validators} from '@angular/forms';
import {FromShipping, Shipping, SiteSummary} from '../../models/shipping';
import * as fromShipping from '../../reducers';
import * as fromOrders from '../../../order/reducers';
import {GroupConfig} from '../../../shared/models/config';
import {GetConfigShippingService} from '../../services/get-config-shipping.service';
import {select, Store} from '@ngrx/store';
import * as fromShared from '../../../shared/reducers';
import {LoadMySitesAction} from '../../../shared/actions/my-sites';
import {distinctUntilChanged, map, takeUntil} from 'rxjs/operators';
import * as _ from 'lodash';
import {LoadSiteSummariesAction} from '../../actions/site-summaries';
import {Client, EMAIL_PATTERN, PHONE_NUMBER_PATTERN, Role} from '../../../shared';
import {UpdateShippingAction} from '../../actions/shipping-update';
import {Observable, Subject, Subscription} from 'rxjs';
import {Site} from '../../../shared/models/site';
import {GetConfigSharedService} from '../../../shared/services/get-config-shared.service';
import * as fromSites from '../../../site/reducers';
import {LoadAddressSummariesAction, LoadAddressSummariesClearAction} from '../../actions/address-summaries';
import {AddressSummaries} from '../../../shared/models/address';
import {FindInvalidControlsService} from '../../../shared/services/find-invalid-controls.service';
import {ClearPdfAzureAction, PdfAzure} from '../../../order/actions/pdfazure';


@Component({
  selector: 'storever-shipping-add',
  templateUrl: './shipping-add.component.html',
  styleUrls: ['./shipping-add.component.scss']
})

export class ShippingAddComponent implements OnInit, OnChanges, OnDestroy {
  @Input() form: FormGroup;
  @Input() shippingForm: FromShipping;
  @Input() isEdit: boolean;
  @Input() isAdd: boolean;
  @Input() shipping: Shipping;
  @Input() isLoading: boolean;
  @Input() siteSummaries: SiteSummary;
  @Input() addressSummaries: AddressSummaries[];
  @Input() dataContext: {context: string, clientId: string, siteId: string, shippingId: string};
  selectOption = true;
  formConfigAddress: GroupConfig;
  formConfigContact: GroupConfig;
  getConfigShippingMisc: GroupConfig;
  getConfigMiscCreated: GroupConfig;
  getConfigSendingType: GroupConfig;
  getConfigBilling: GroupConfig;
  getConfigGeneral: GroupConfig;
  getConfigWaybill: GroupConfig;
  clientUuidSelected: string;
  private sub$: Subscription;
  private subscriptions = [];
  roles$: Observable<Role[]>;
  // tslint:disable-next-line:no-any
  shipping$: Observable<any>;
  // tslint:disable-next-line:no-any
  pdfazure$: Observable<any>;
  ordertypepdf = '';
  ordernumberpdf = '';
  trackingnumber: string;
  orderid: string;
  // tslint:disable-next-line:no-any
  order$: Observable<any>;
  showWaybill: boolean;
  openWindowwaybill: string;
  private readonly destroy$ = new Subject<void>();



  constructor(private getConfigShipping: GetConfigShippingService,
              private store: Store<fromShared.AppState>,
              private findInvalidControlsService: FindInvalidControlsService,
              private getConfigSharedService: GetConfigSharedService) {
    this.roles$ = this.store.pipe(select(fromShared.selectors.getMyRoles));
  }


  ngOnInit(): void {

    this.order$ = this.store.pipe(select(fromOrders.selectors.getOrder));
    this.shipping$ = this.store.pipe(select(fromShipping.selectors.getShipping));
    this.pdfazure$ = this.store.pipe(select(fromOrders.selectors.getPdf));

    this.formConfigAddress = this.getConfigShipping.getConfigShippingAddress();
    this.formConfigContact = this.getConfigShipping.getConfigShippingContact();
    this.getConfigShippingMisc = this.getConfigShipping.getConfigShippingMisc();
    this.getConfigMiscCreated = this.getConfigShipping.getConfigShippingMiscCreated();
    this.getConfigWaybill = this.getConfigShipping.getConfigwaybill();


    if (this.isEdit) {
     const sendingType = this.getConfigShipping.getConfigShippingSendingType()
     sendingType.config[5].options.datePicker.numberDelayDays = 0;
     this.getConfigSendingType = sendingType;
    } else {
      this.getConfigSendingType = this.getConfigShipping.getConfigShippingSendingType();
    }
    this.getConfigBilling = this.getConfigShipping.getConfigShippingBilling();
    this.getConfigGeneral = this.getConfigShipping.getConfigShippingGeneral();

    if (this.form) {
      this.clientChange();
      this.siteChange();
    }


    this.openwaybill()


    // tslint:disable-next-line:no-any
    this.sub$ = this.pdfazure$.pipe().subscribe((data: any) => {

      if (data === null) {
        this.showWaybill = false;
      }
      if (data)  {
        this.showWaybill = true;
        this.openWindowwaybill = data;
      }
     });

    this.subscriptions.push(this.sub$);
  }

  save(value: string): void {
    const resp = this.form.getRawValue();
    this.store.dispatch(new UpdateShippingAction(resp));
  }

  clientChange(): void {
    this.sub$ = this.form.get(['general', 'clientUuid']).valueChanges.pipe(
      distinctUntilChanged((x, y) => _.isEqual(x, y))).subscribe(val => {
      if (val ) {
        this.store.dispatch(new  LoadAddressSummariesClearAction());
        this.clientUuidSelected = val;
        this.patchClient(val);
        this.store.dispatch(new LoadMySitesAction(val));
        this.store.dispatch(new LoadAddressSummariesAction(val));
        this.selectOption = true;
        this.form.get('contact').reset();
        this.form.get('address').reset();
        this.form.get(['general', 'siteName']).reset();
        this.form.get(['general', 'siteUuid']).reset();
      }
    });
    this.subscriptions.push(this.sub$);
  }

  siteChange(): void {
    this.sub$ = this.form.get(['general', 'siteUuid']).valueChanges.pipe(
      distinctUntilChanged((x, y) => _.isEqual(x, y))).subscribe(val => {
      if (val ) {
        this.patchSite(val);
        this.store.dispatch(new LoadSiteSummariesAction({ clientUuid: this.clientUuidSelected, siteUuid: val }));
    }
    });
    this.subscriptions.push(this.sub$);
    this.sub$ = this.form.get(['general', 'siteName']).valueChanges.subscribe(val => {
      if ( !val ) {
        if (this.isAdd) {
          this.form.get('contact').reset();
          this.form.get('address').reset();
        }
        this.form.get(['general']).patchValue({
          'siteUuid': null,
        });
        this.formConfigAddress = this.getConfigShipping.getConfigShippingAddress();
        this.formConfigContact = this.getConfigShipping.getConfigShippingContact();
        this.form.get(['contact' , 'email']).setValidators([Validators.required]);
        this.form.get(['contact' , 'name']).setValidators([Validators.required]);
        this.form.get(['contact' , 'phone']).setValidators([Validators.required]);
        this.form.get(['contact' , 'surname']).setValidators([Validators.required]);
        this.form.get('contact').updateValueAndValidity();
        this.form.get(['address' , 'countryForm' , 'name']).setValidators([Validators.required]);
        this.form.get(['address' , 'line1']).setValidators([Validators.required]);
        this.form.get(['address' , 'city']).setValidators([Validators.required]);
        this.form.get(['address' , 'zip']).setValidators([Validators.required]);
        this.form.get('address').updateValueAndValidity();
      }

    });
    this.subscriptions.push(this.sub$);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.siteSummaries && changes.siteSummaries.currentValue) {
      this.patchSummariesValue(changes.siteSummaries.currentValue);
    }
    if (changes.form && changes.form.currentValue) {
      this.patchGeneralIfParamMap();
    }
  }

  patchGeneralIfParamMap(): void {
    if (this.dataContext) {
      const clientId = this.dataContext.clientId;
      const siteId = this.dataContext.siteId;
      this.store.pipe(select(fromShared.selectors.getCurrentClient)).subscribe((client: Client) => {
        if (client) {
          this.patchClient(client.uuid);
          this.form.get(['general']).patchValue( {'clientName':  client.name  });
          this.form.get(['general', 'clientName']).disable({ onlySelf: true });
        }
      });
      this.store.pipe(select(fromSites.selectors.getSite)).subscribe((site: Site) => {
        if (site) {
          this.patchSite(site.uuid);
          this.form.get(['general']).patchValue( {'siteName':  site.name  });
          this.form.get(['general', 'siteName']).disable({ onlySelf: true });
        } else if (siteId) {
          this.patchSite(siteId);
          this.form.get(['general', 'siteName']).disable({ onlySelf: true });
        }
      });
      this.store.dispatch(new LoadSiteSummariesAction({ clientUuid: clientId, siteUuid: siteId }));
    }
  }

  patchSummariesValue(site: SiteSummary): void {
    if (this.form) {
      this.form.get(['address' , 'countryForm' , 'name']).clearValidators();
      this.form.get(['address' , 'line1']).clearValidators();
      this.form.get(['address' , 'city']).clearValidators();
      this.form.get(['address' , 'zip']).clearValidators();
      this.form.get('address').updateValueAndValidity();
      this.form.get(['address', 'countryForm', 'name']).patchValue(site.address.country);
      this.form.get('address').patchValue(site.address);
      if (site.contact) {
        this.form.get(['contact' , 'email']).clearValidators();
        this.form.get(['contact' , 'name']).clearValidators();
        this.form.get(['contact' , 'phone']).clearValidators();
        this.form.get(['contact' , 'surname']).clearValidators();
        this.form.get('contact').updateValueAndValidity();
        this.form.get('contact').patchValue(site.contact);
        this.formConfigAddress = this.getConfigSharedService.getConfigSharedAddressReadOnly();
        this.formConfigContact = this.getConfigSharedService.getConfigSharedContactReadOnly();
        this.selectOption = false;
      } else {
        this.form.get('contact').reset();
        this.formConfigAddress = this.getConfigShipping.getConfigShippingAddress();
        this.formConfigContact = this.getConfigShipping.getConfigShippingContact();
        this.selectOption = true;
      }

      this.form.get(['billing', 'office', 'id']).patchValue(site.office);
    }
  }

  patchClient(value: string): void {
    if (this.form) {
      this.form.get(['general']).patchValue(
        {
          'clientUuid':  value ,
        }
      );
    }
  }

  // tslint:disable-next-line:no-any
  patchSite(value: { name: string, uuid: string } | any): void {
    if (this.form) {
      this.form.get(['general']).patchValue({
          'siteUuid': value,
      });
    }
  }

  undo(formPath: string[]): void {
    if (formPath[1] !== 'commentsForm') {
      this.patchValueNotCommentForm(formPath);
    } else {
      this.form.get(formPath.concat('comments')).reset();
    }
  }

  patchValueNotCommentForm(formPath: string[]): void {
    this.form.get(formPath).patchValue(_.get(this.shippingForm, formPath)); // normal update undo form
    this.form.get(formPath).markAsPristine();
  }

  ngOnDestroy(): void {
    // this.store.dispatch(new  LoadAddressSummariesClearAction());
    this.destroy$.next();
    this.destroy$.complete();
    this.store.dispatch(new ClearPdfAzureAction());
    this.subscriptions.forEach(sub => {
      sub.unsubscribe();
    });
  }
  isInRole$(role: string): Observable<boolean> { return this.roles$.pipe(map(roles => _.findIndex(roles, ['code', role]) > -1)); }

  // tslint:disable-next-line:no-any
  updateAddressAndContact(value: any): void {
    if (!value) {
     // this.form.get('contact').reset();
     // this.form.get('address').reset();
    } else {
      const site = _.find(this.addressSummaries, gr => gr.addressType.replace(/ /g, '') === value.replace(/ /g, ''));
      if (this.form) {
        this.form.get('address').patchValue(site.address);
        this.form.get(['address', 'countryForm', 'name']).patchValue(site.address.country);
        if (site.contact) {
          this.form.get('contact').patchValue(site.contact);
        }
      }
    }
  }

  getInvalidControls(form: FormGroup): string[] {
    if (isDevMode()) {
      return this.findInvalidControlsService.find(form);
    }
  }

  openwaybill(): void {
    // tslint:disable-next-line:no-any
    this.sub$ = this.shipping$.pipe(takeUntil(this.destroy$)).subscribe((data: any) => {
      if (data && data.id && data.type && data.tracking) {
     const orderType = data.type === 2 ? 'deploy' : 'exchange';
     this.ordertypepdf = orderType;

        // tslint:disable-next-line:no-any
     this.sub$ =  this.order$.pipe(takeUntil(this.destroy$)).subscribe((order: any) => {
      if (order) {
        this.orderid = order.id ;
      }

     });
     this.subscriptions.push(this.sub$);

     const azurepdf = {
      ordernumber: this.orderid,
      trackingnumber: data.tracking,
      ordertype: this.ordertypepdf,
      documenttype: 1,
    };
     if (azurepdf.ordernumber && azurepdf.trackingnumber && azurepdf.ordertype) {
     this.store.dispatch(new PdfAzure(azurepdf));

    }
    else {
      this.showWaybill = false;
    }
      }

    });
    this.subscriptions.push(this.sub$);

  }


  openwindow(): void {
    window.open(this.openWindowwaybill)

  }
}
